import { mapGetters } from "vuex";
import EntitySelect from "@/view/components/EntitySelect.vue";
import {
    SET_ENTITY_DIALOG, CLEAR_ENTITY,SET_ENTITY
} from "@/core/services/store/entity.module";
import { currentUser } from "@/core/services/jwt.service";
export default {
    data() {
        return {

        };
    },
    components: {
        "entity-select": EntitySelect,
    },
    methods: {
        openEntityDialog() {
            if (this.lodash.toSafeInteger(this.$route?.params?.id) > 0) {
                return false
            }
            if (this.lodash.toSafeInteger(this.$route?.query?.edit) > 0) {
                return false
            }
            if (!this.loginUser.is_main_admin) {
                return false
            }
            this.$store.commit(SET_ENTITY_DIALOG, false);
            this.$store.commit(SET_ENTITY_DIALOG, true);
        },
        closeEntityDialog() {
            this.$store.commit(SET_ENTITY_DIALOG, false);
        },
    },
    computed: {
        ...mapGetters([
            "vEntityDialog", "reEntityId", "reEntity"
        ]),
        loginUser() {
            return currentUser();
        },
    },
    beforeCreate() {
        this.$store.dispatch(CLEAR_ENTITY);
    },
    destroyed() {
        this.$store.dispatch(CLEAR_ENTITY);

    },
    mounted() {
        if(!this.loginUser.is_main_admin){ 
          this.$store.commit(SET_ENTITY,this.loginUser.entity_relation);
        }
    },

};
